module.exports = __webpack_public_path__ + "static/media/cat2.6d836c0a.jpeg";